import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { hasOnboardingOperatorPermission, isAdminLocalDev } from './adminAccess'

export { hasOnboardingOperatorPermission } from './adminAccess'

// The white-glove onboarding surface (/admin/onboarding) accepts either the
// broad service-controlled admin role or the scoped "onboarding_operator"
// permission. The backend require_onboarding_operator 403 is the real
// boundary; this guard only decides which affordance to render.
//
// Reads app_metadata ONLY — user_metadata is client-editable and must never
// gate an operator affordance. The claim is baked into the JWT at issue time,
// so a freshly granted operator only sees the route after a token refresh /
// re-login (accepted: the backend 403 stays authoritative until then).
//
// NOTE on the local-dev bypass: it mirrors AdminTopupRoute / AdminFlagsRoute,
// but unlike those the BACKEND gate deliberately does not carry a matching
// debug-user short-circuit — require_onboarding_operator admits debug-user
// only when the API is also provably local, and refuses real external effects
// in that mode. So this bypass shows the page in local dev; it does not make
// the tool usable against a deployed API.
/**
 * Route guard for `/admin/onboarding`.
 *
 * Renders the surface for a broad admin or a scoped `onboarding_operator`,
 * and redirects everyone else to the dashboard. This is an affordance, not a
 * security boundary — `require_onboarding_operator` on the API is.
 */
export default function OnboardingAdminRoute() {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (isAdminLocalDev() || hasOnboardingOperatorPermission(user)) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
